import React, { useEffect } from "react";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "../HomePage/HomeFooter";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navigation />
      <div className="policy-page">
        {" "}
        <button className="back-btn" onClick={() => window.history.back()}>
          ⬅ Povratak
        </button>
        <div className="policy-container">
          <h1>Uvjeti korištenja</h1>
          <p className="last-updated">Zadnja izmjena: Lipanj, 2026.</p>

          <section>
            <h2>1. Opće odredbe</h2>
            <p>
              Korištenjem ove aplikacije pristajete na ove Uvjete korištenja.
              Aplikacija je namijenjena isključivo informiranju sudionika i
              posjetitelja o tijeku, rasporedu i rezultatima Malonogometnog
              turnira Podsused.
            </p>
          </section>

          <section>
            <h2>2. Točnost informacija</h2>
            <p>
              Organizacijski odbor ulaže maksimalne napore kako bi podaci na
              aplikaciji bili točni i pravovremeni. Ipak, zadržavamo pravo na
              pogreške pri unosu ili izmjene rasporeda u zadnji trenutak zbog
              više sile (vremenske prilike, tehnički problemi). Službeni podaci
              zapisnika utakmice imaju prednost nad podacima u aplikaciji.
            </p>
          </section>

          <section>
            <h2>3. Ponašanje korisnika</h2>
            <p>
              Zabranjeno je svako neovlašteno pokušavanje pristupa
              administraciji aplikacije, manipulacija podacima ili korištenje
              automatiziranih sustava (botova) za prikupljanje podataka s ove
              platforme.
            </p>
          </section>

          <section>
            <h2>4. Pravo na izmjene</h2>
            <p>
              Organizacijski odbor zadržava pravo izmjene pravila turnira,
              sustava natjecanja te diskvalifikaciju ekipa koje se ne
              pridržavaju sportskog kodeksa ili pravila turnira. Sve obavijesti
              objavljene unutar aplikacije smatraju se važećima.
            </p>
          </section>

          <section>
            <h2>5. Ograničenje odgovornosti</h2>
            <p>
              Organizator se odriče odgovornosti za bilo kakvu štetu nastalu
              oslanjanjem isključivo na informacije iz aplikacije u situacijama
              koje zahtijevaju prisutnost na samom terenu (npr. promjena termina
              utakmice uživo).
            </p>
          </section>
          <section>
            <h2>6. Prikaz podataka i privatnost</h2>
            <p>
              Podaci o strijelcima i igračima prikazuju se u skraćenom obliku
              (npr. I. Prezime) u svrhu zaštite privatnosti, ali i osiguravanja
              transparentnosti rezultata. Imena ekipa i sponzora su javni podaci
              turnira.
            </p>
          </section>

          <section>
            <h2>7. Vanjske poveznice (Sponzori)</h2>
            <p>
              Aplikacija sadrži poveznice na web stranice naših partnera i
              sponzora. MNT Podsused nema kontrolu nad sadržajem tih stranica
              niti snosi odgovornost za politike privatnosti ili uvjete
              korištenja trećih strana.
            </p>
          </section>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default TermsOfUse;
